import { useOrganization } from "@/hooks/use-organization";
import { Permission, useRolePermissions } from "@/hooks/use-role-permissions";

/** Org-side gates for sending form templates from a chat composer. */
export function useChatFormAccess(
  user: { is_admin: boolean } | null | undefined,
): { canManageJobPosts: boolean; documentSigningEnabled: boolean } {
  const { selectedOrgBusinessUnit } = useOrganization();
  const { hasPermission } = useRolePermissions(user);

  return {
    canManageJobPosts: hasPermission(Permission.ManageJobPosts),
    documentSigningEnabled:
      selectedOrgBusinessUnit.enableDocumentSigning === true,
  };
}
